module.exports = __webpack_public_path__ + "media/futuristic_ping.5ceec907.webm";